import { flickityContainNavigation } from 'utils'

$(document).on('turbolinks:load', () => {
  flickityContainNavigation('.watch_featured_section .slider')
})
